import Termly from 'termly-namespace'

import CurrentRegionSettings from 'constants/current-region-settings'

import isCookiePolicyVersionUpdated from './isCookiePolicyVersionUpdated'
import isCookieConsentExpired from './isCookieConsentExpired'


export default function shouldRenderReminder({ cookiePolicy }) {
  if ( !cookiePolicy ) {
    return false
  }

  // A region can suppress the prompt while the rest of the CMP keeps running:
  // blocking still follows `consent_mode`, and the preference center is still
  // reachable.
  if ( CurrentRegionSettings.isBannerSuppressed() ) {
    return false
  }

  if ( Termly.tcf?.isConsentableContentVersionChanged ) {
    return true
  }

  if ( isCookieConsentExpired() ) {
    return true
  }

  return isCookiePolicyVersionUpdated(cookiePolicy)
}
